<template>
  <div class="staff-popover">
    <mk-popover
      v-if="!isBatch"
      placement="bottom-start"
      trigger="hover"
      :width="width"
    >
      <div
        slot="reference"
        class="show-more-button"
      >
        <ds-iconfont icon-class="icon-mk-tishi-info" />
        仅支持指定员工查看
      </div>
      <div>
        <div class="title">
          <ds-iconfont icon-class="icon-mk-tishi-info" />
          最多展示前100个指定员工/部门
        </div>
        <div class="tag-wrapper">
          <mk-tag
            v-for="(item, index) in limitedList"
            :key="index"
            class="tag-item"
          >
            {{ item.name }}
          </mk-tag>
        </div>
      </div>
    </mk-popover>
    <ds-iconfont
      v-else
      icon-class="icon-ds-gengduo"
    />
  </div>
</template>

<script>
export default {
  name: 'StaffPopover',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 同popover witdt属性
    width: {
      type: [Number, String],
      default: '380'
    },
    isBatch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 前100位
    limitedList () {
      return this.list.slice(0, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.show-more-button,
.title {
  .icon-mk-tishi-info {
    color: #009cff;
    margin-right: 4px;
  }

  font-size: 13px;
  color: #595959;
}

.tag-wrapper {
  margin-top: 5px;
  max-height: 500px;
  overflow-y: auto;
}

.tag-item {
  margin: 8px 0 0 8px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border: none;
  background-color: #f3f3f3;
  color: #595959;
  border-radius: 2px;
}
</style>
